var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-742.804 -633.798)"},[React.createElement("g",{"transform":"translate(752.405 635.798)","fill":"none","stroke":"#9d9fa6","strokeLinecap":"round","strokeWidth":"2","key":0},[React.createElement("ellipse",{"cx":"10.995","cy":"10.995","rx":"10.995","ry":"10.995","stroke":"none","key":0}),React.createElement("ellipse",{"cx":"10.995","cy":"10.995","rx":"11.995","ry":"11.995","fill":"none","key":1})]),React.createElement("path",{"d":"M10,.958.6,10.047","transform":"translate(744.325 654.446)","fill":"#c4c5ca","stroke":"#9d9fa6","strokeLinecap":"round","strokeWidth":"3","key":1})]));
}

Search.defaultProps = {"focusable":"false","viewBox":"0 0 33.591 32.816"};

module.exports = Search;

Search.default = Search;
